import { isEmpty } from 'lodash';

export default function reformatCollections(collections) {

    /*

    We need to reformat collections - Phoenix sends like this:

    "collections":{
        "collected_gigs": [104176703],
        "collections": [
            {
                "name":"V4 favs",
                "gigs":[104176703],
                "active":true
            }
        ]
    }

    but the NPM packages expect them like this:

    "collections": {
        "collected_gigs": [104176703],
        "collections": {
            "V4 favs": {
                "gigs": [104176703],
                "active": true
            }
        }
    }

    */

    let collectionsFormatted = {};

    if (!isEmpty(collections)) {

        collectionsFormatted = {
            collected_gigs: collections.collected_gigs,
            collections: {}
        };

        if (!isEmpty(collections.collections)) {

            collections.collections.forEach((coll) => {
                collectionsFormatted.collections[coll.name] = coll;
            });

        }
    }

    return collectionsFormatted;
}